export default "__VITE_ASSET__6eb2ccac__"